import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse }
  from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { Routes, Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { map, catchError,retry } from 'rxjs/operators';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';


@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  dialogConfig:any;
  loading:boolean = false;

  constructor(
    public auth: AuthService, 
    private _router: Router,
    public dialog: MatDialog
    ) { 
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        // Authorization: `Bearer ${this.auth.getToken()}`
        // tslint:disable-next-line:max-line-length
        'Authorization': `Bearer ${this.auth.getToken()}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
    return next.handle(request).pipe(retry(1),catchError((error: HttpErrorResponse) => {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        // client-side error
       errorMessage = `Error: ${error.error.message}`;
      } else {
        // server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        if (error.status == 500) {
        } else if (error.status == 400) {
          if (error.error.errors.invalid_process) {
            this.dialog.open(NotifyboxComponent, {
              data: {
                message: error.error.errors.invalid_process
              }
            });
          }
          if (error.error.errors.failed) {
            this.dialog.open(NotifyboxComponent, {
              data: {
                reload:false,
                message: error.error.errors.failed[0]
              }
            });
          }
          if (error.error.errors.itinerary) {
            this.dialogConfig = new MatDialogConfig();
            this.dialogConfig.autoFocus = false;
            this.dialogConfig.disableClose = true;
            this.dialogConfig.width = '400px';
            this.dialogConfig.data = {
              reload:false,
              message: error.error.errors.itinerary[0]
            }
            this.dialog.open(NotifyboxComponent,this.dialogConfig);
          }
        } else if (error.status == 401) {
          this.loading = false;
          this.dialog.open(NotifyboxComponent, {
           disableClose:true,
           data: {
             label:'Ok',
            reload: false,
            message: 'You have been logout due to inactivity.'
           }
          }).afterClosed().subscribe(result => {
            window.location.reload();
          });
        }
      }
      return throwError(error);
      }));
  }
}
